import { LOCAL_CURRENCY_CALCULATED_DATASOURCES } from '../eo_mapping/datasources';
import { DRUID_TO_HUMAN_READABLE } from '../eo_mapping';
import {
  METADATA_TYPE,
  COLUMN_METADATA,
  POPOVERS,
  GROUPS,
  COLUMN_HEADER_STYLE,
  FORMULAS,
  GRADIENT_COLUMNS,
} from './eo_constants';
import { getColumnDataFieldKey, getCustomEventName, getUnderlyingDataSources } from './eo_helpers';
import type { ColumnType } from './eo_types';
import type { IColumn } from '../../types/IColumn';

export type BuildColumnProps = {
  type: ColumnType;
  key: string;
  sources?: any;
  formulas?: any;
  addAllFormulas?: boolean;
  extensions?: any;
  localCurrency?: string;
  overrides?: Partial<IColumn>;
};

export const buildColumn = (props: BuildColumnProps): IColumn => {
  const { type, key, sources, extensions, addAllFormulas, formulas, localCurrency, overrides } = props;

  const display = DRUID_TO_HUMAN_READABLE[key] || getCustomEventName(key);
  const reportColumnKey = getColumnDataFieldKey(type, key);
  const reportDataKey = reportColumnKey || key;

  const column: IColumn = {
    reportColumnKey,
    reportDataKey,
    type,
    key,
    display,
  };

  if (METADATA_TYPE[type]) {
    Object.assign(column, { ...METADATA_TYPE[type] });
  }

  // set column metadata based on column key. Can overwrite METADATA_TYPE properties
  if (COLUMN_METADATA[key]) {
    Object.assign(column, { ...COLUMN_METADATA[key] });
  }

  if ((addAllFormulas || formulas?.includes(key)) && FORMULAS[key]) {
    column.formulas = FORMULAS[key];
  }

  const popover = POPOVERS[key];
  if (popover) {
    column.popover = popover;
  }

  const group = GROUPS[key] || extensions?.GROUPS?.[key];
  if (group) {
    column.group = group;
  }

  const className = COLUMN_HEADER_STYLE[key];
  if (className) {
    column.className = className;
  }

  if (key in GRADIENT_COLUMNS) {
    column.gradient = true;
  }

  const dataSources = getUnderlyingDataSources(type, sources, key);
  if (dataSources) {
    column.dataSources = dataSources;
  }

  if (localCurrency && LOCAL_CURRENCY_CALCULATED_DATASOURCES.includes(key)) {
    column.localCurrency = localCurrency;
  }

  if (overrides) {
    Object.assign(column, overrides);
  }

  return column;
};
